import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Lock } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { api, ERROR_TEXT, EMPTY_TEXT } from "@/lib/api";
import { PageHead, Skeleton } from "@/components/hm/Basics";
import { BreathOrb, BreathSteps, BreathButton, useBreath } from "@/components/hm/BreathOrb";

const BreathCard = () => {
  const b = useBreath();
  return (
    <section id="respira" className="card breathe" style={{ marginBottom: 24, scrollMarginTop: 90 }} data-testid="breath-exercise">
      <div>
        <span className="eyebrow">Ejercicio guiado · 1 minuto</span>
        <h2 className="hm-h2" style={{ marginTop: ".9rem" }}>Respira para volver a la calma</h2>
        <p className="text-muted" style={{ marginTop: ".8rem" }}>Inhala 5, exhala 5. Seis ciclos. Si te mareas, vuelve a respirar normal.</p>
        <BreathSteps phase={b.phase} />
        <BreathButton b={b} />
      </div>
      <div style={{ maxWidth: 320, width: "100%", margin: "0 auto" }}><BreathOrb b={b} /></div>
    </section>
  );
};

export default function Recursos() {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(false);
  const { hash } = useLocation();
  useEffect(() => { api.get("/resources").then((r) => setItems(r.data)).catch(() => setError(true)); }, []);
  useEffect(() => { if (hash === "#respira") setTimeout(() => document.getElementById("respira")?.scrollIntoView({ behavior: "smooth" }), 200); }, [hash]);

  return (
    <div data-testid="recursos-page">
      <PageHead eyebrow="Recursos" title="Para cuando" serif="lo necesites." lead="Ejercicios cortos. Puedes volver a ellos siempre." />
      <BreathCard />
      {error && <p className="text-danger" data-testid="recursos-error">{ERROR_TEXT}</p>}
      {!items && !error && <Skeleton n={4} h={76} />}
      {items?.length === 0 && <p className="text-muted">{EMPTY_TEXT}</p>}
      <Accordion type="single" collapsible className="grid gap-3">
        {items?.map((r) => (
          <AccordionItem key={r.id} value={r.id} className="res-item" data-testid={`resource-${r.id}`}>
            <AccordionTrigger className="py-5 text-left hover:no-underline" data-testid={`resource-toggle-${r.id}`}>
              <div>
                <p className="text-faint" style={{ margin: 0, font: "500 11.5px/1 var(--mono)", letterSpacing: ".08em", textTransform: "uppercase" }}>{r.kind}</p>
                <p style={{ margin: ".5rem 0 0", fontWeight: 600 }}>{r.title}</p>
              </div>
            </AccordionTrigger>
            <AccordionContent>
              {r.locked ? (
                <p className="text-muted inline-flex items-center gap-2" style={{ margin: "0 0 1rem", fontSize: 14 }}>
                  <Lock size={14} /> Incluido en los planes.
                  <Link to="/planes" className="text-accent font-semibold" data-testid={`resource-plans-link-${r.id}`}>Ver los planes</Link>
                </p>
              ) : <ol>{r.body.map((p) => <li key={p}>{p}</li>)}</ol>}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
